import React from 'react';
import { CheckIcon, BookOpenIcon, GiftIcon } from 'lucide-react';
import { tomos, tomoIncludes, bonos } from '../data/offer';
import { Reveal } from './ui/Reveal';
const cases = ["11-18", 'Familia separada', 'Crisis emocional', 'Todo funcionando'];
export function TomosSection() {
  return <section id="megapack" aria-labelledby="tomos-title" className="border-b border-line bg-ink" data-id="element-267" data-mp="1u2dh2huga230">
      <div className="mx-auto max-w-content px-5 pb-16 pt-12 sm:px-8 lg:pb-24 lg:pt-16" style={{
      paddingTop: "18px",
      paddingBottom: "19px"
    }} data-id="element-268" data-mp="xcnv0104ysld">
        <div className="mx-auto max-w-3xl text-center" data-id="element-269" data-mp="11e99trw8dgy7">
          <h2 id="tomos-title" className="text-2xl font-black leading-tight tracking-tight text-ivory sm:text-3xl lg:text-4xl" style={{
          fontSize: "11px",
          color: "#F6A93B",
          fontWeight: "400"
        }} data-id="element-270" data-mp="16csxbwqh30so">
            ÓRBITA DIGITAL™ MEGAPACK RECONEXÓN
          </h2>
          <p className="mt-4 text-base text-muted sm:text-lg" style={{
          fontSize: "15px",
          fontWeight: "500",
          color: "#FFFFFF"
        }} data-id="element-271" data-mp="2mqj6hhwg8f96">6 Tomos + 6 Bonos.</p>
          <p className="mt-2 text-lg font-black text-accent sm:text-xl" style={{
          fontSize: "15px"
        }} data-id="element-272" data-mp="2mm3tsuxgje0r">
            360+ páginas — Todo listo para aplicar.
          </p>
        </div>

        <ul className="mx-auto mt-6 flex max-w-2xl flex-wrap items-center justify-center gap-2" aria-label="Casos cubiertos" data-id="element-273" data-mp="2coz3qk0hqyeo">
          {cases.map(c => <li key={c} className="flex items-center justify-center rounded-lg border border-line bg-surface px-2.5 py-1.5 text-center text-[10px] font-semibold uppercase leading-none tracking-wide text-muted sm:text-[11px]" style={{
          fontSize: "8px",
          fontWeight: "400"
        }} data-id="element-274" data-mp="27qxlg1aw3349">
              {c}
            </li>)}
        </ul>

        <div className="mt-12 grid gap-6 lg:grid-cols-2" style={{
        gap: "0px"
      }} data-id="element-275" data-mp="1oyllfl7pkdxa">
          <Reveal className="h-full" data-id="element-276" data-mp="1k01z3jp7d04e">
            <div className="flex h-full flex-col rounded-2xl border border-line bg-surface p-6 sm:p-7" style={{
            paddingTop: "8px",
            paddingBottom: "11px"
          }} data-id="element-277" data-mp="1k13axqe1lqn6">
              <h3 className="flex items-center gap-2 text-lg font-black tracking-tight text-ivory" style={{
              fontSize: "14px",
              textAlign: "center",
              alignItems: "center",
              justifyContent: "center"
            }} data-id="element-278" data-mp="1fcaju8lcfub7">
                <BookOpenIcon aria-hidden="true" className="h-5 w-5 shrink-0 text-accent" data-id="element-279" data-mp="1t2xmucy506d3" />
                 6 TOMOS 
              </h3>
              <p className="mt-1.5 text-sm text-muted" data-id="element-280" data-mp="1y0fkv8am916b">
</p>
              <ol className="mt-6 space-y-3" data-id="element-281" data-mp="1kalv8nraecvj">
                {tomos.map(tomo => <li key={tomo.number} className="flex items-start gap-3" data-id="element-282" data-mp="1ka3tjbluv6g8">
                    <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-md bg-surfaceAlt text-xs font-black text-accent" data-id="element-283" data-mp="1oamjt183o4gb">
                      {tomo.number}
                    </span>
                    <span className="text-[15px] leading-snug text-ivory" style={{
                  fontSize: "12px"
                }} data-id="element-284" data-mp="2gtjgv0bb3q43">
                      <span className="font-semibold text-accent" data-id="element-285" data-mp="eg3cahmssmk">{tomo.tag}</span> · {tomo.title}
                    </span>
                  </li>)}
              </ol>
            </div>
          </Reveal>

          <Reveal delay={0.05} className="h-full" data-id="element-286" data-mp="a49h9i58xjtz">
            
          </Reveal>
        </div>

        <div className="mt-6 rounded-2xl border border-line bg-surfaceAlt p-6 sm:p-8" style={{
        paddingTop: "9px",
        paddingBottom: "11px"
      }} data-id="element-287" data-mp="3ijjcq7emrqss">
          <h3 className="text-center text-base font-black uppercase tracking-wide text-ivory sm:text-lg" style={{
          fontSize: "12px",
          fontWeight: "400"
        }} data-id="element-288" data-mp="3dmj69vdvcm15">
            Cada tomo incluye
          </h3>
          <ul className="mx-auto mt-6 grid max-w-3xl gap-3 sm:grid-cols-2" data-id="element-289" data-mp="17rq7ghr7urw3">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-muted" style={{
            fontSize: "12px"
          }} data-id="element-290" data-mp="12snbrnx4ly0s">
                <CheckIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-success" data-id="element-291" data-mp="38iidtub3n8zd" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}